import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-stone-50 px-6">
      <p className="text-sm text-stone-600">That page does not exist.</p>
      <Link to="/" className="text-sm font-medium text-stone-900 underline underline-offset-4">
        Go back
      </Link>
    </div>
  );
}
